import React from "react";
import { Activity, Calendar, Receipt, User, Clock, Gift } from "lucide-react";
import type { TFunction } from "i18next";

/**
 * GuestPortalNav - Mobile bottom-style tab navigation for the guest portal.
 *
 * @param {Object} props - Component props.
 * @param {string} props.activeTab - Currently active tab key.
 * @param {Function} props.setActiveTab - Sets the active tab.
 * @param {Function} props.t - i18n translation function.
 * @returns {React.ReactElement} The rendered mobile navigation.
 */
export default function GuestPortalNav({
  activeTab,
  setActiveTab,
  t,
}: {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  t: TFunction;
}) {
  return (
    <nav className="md:hidden flex items-center justify-around bg-surface border-b border-border p-2 shadow-inner">
      <button
        onClick={() => setActiveTab("dashboard")}
        className={`flex flex-col items-center gap-0.5 p-2 rounded-xl text-[9px] font-black uppercase tracking-wider w-full ${activeTab === "dashboard" ? "text-accent" : "text-muted"
          }`}
      >
        <Activity size={18} />
        <span>{t("guestPortal.portal")}</span>
      </button>
      <button
        onClick={() => setActiveTab("reservations")}
        className={`flex flex-col items-center gap-0.5 p-2 rounded-xl text-[9px] font-black uppercase tracking-wider w-full ${activeTab === "reservations" ? "text-accent" : "text-muted"
          }`}
      >
        <Calendar size={18} />
        <span>{t("guestPortal.stays")}</span>
      </button>
      <button
        onClick={() => setActiveTab("invoices")}
        className={`flex flex-col items-center gap-0.5 p-2 rounded-xl text-[9px] font-black uppercase tracking-wider w-full ${activeTab === "invoices" ? "text-accent" : "text-muted"
          }`}
      >
        <Receipt size={18} />
        <span>{t("guestPortal.receipts")}</span>
      </button>
      <button
        onClick={() => setActiveTab("requests")}
        className={`flex flex-col items-center gap-0.5 p-2 rounded-xl text-[9px] font-black uppercase tracking-wider w-full ${activeTab === "requests" ? "text-accent" : "text-muted"
          }`}
      >
        <Clock size={18} />
        <span>{t("guestPortal.requestsTab")}</span>
      </button>
      <button
        onClick={() => setActiveTab("rewards")}
        className={`flex flex-col items-center gap-0.5 p-2 rounded-xl text-[9px] font-black uppercase tracking-wider w-full ${activeTab === "rewards" ? "text-accent" : "text-muted"
          }`}
      >
        <Gift size={18} />
        <span>{t("guestPortal.rewardsTab")}</span>
      </button>
      <button
        onClick={() => setActiveTab("profile")}
        className={`flex flex-col items-center gap-0.5 p-2 rounded-xl text-[9px] font-black uppercase tracking-wider w-full ${activeTab === "profile" ? "text-accent" : "text-muted"
          }`}
      >
        <User size={18} />
        <span>{t("guestPortal.profileTab")}</span>
      </button>
    </nav>
  );
}
